<template>
  <el-button
    :type="type"
    :plain="plain"
    :loading="$loadings.excel_import"
    @click="visible = true"
  >
    <slot name="title">{{ title }}</slot>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :center="center"
      append-to-body
      :width="width"
      :before-close="beforeClose"
    >
      <div :class="{ 'is-center': center }">
        <el-form
          :model="data"
          ref="form"
          hide-required-asterisk
          v-bind="formAttr"
        >
          <slot />
        </el-form>
        <el-form
          class="file-upload__wrap"
          slot="trigger"
          v-bind="formAttr"
        >
          <el-form-item :label="label">
            <el-upload
              action="#"
              :multiple="multiple"
              :show-file-list="false"
              :accept="accept"
              :on-change="fileChange"
              :file-list="fileList"
              :auto-upload="false"
              ref="upload"
              class="file-upload__inner"
            >
              <el-input
                :value="inputValue"
                clearable
                :readonly="disabled"
                :placeholder="placeholder"
                class="excel-import__input"
                @click.native="handleClick"
                @clear="handleClear"
              />
              <el-button
                type="default"
                plain
              >浏览</el-button>
            </el-upload>
          </el-form-item>
          <ul
            v-if="multiple && fileList.length > 0"
            class="file-upload__filelist"
          >
            <li
              v-for="{ name, uid } in fileList"
              :key="uid"
              :span="24"
            >
              <el-tag
                type="info"
                closable
                effect="plain"
                size="large"
                :title="name"
                @close="handleClose(uid)"
              >{{ name }}</el-tag>
            </li>
          </ul>
          <slot name="append"></slot>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          plain
          style="width: 106px"
          :loading="$loadings.excel_import"
          :disabled="disabled"
          @click="submit"
        >确认上传</el-button>
        <el-button
          plain
          style="width: 106px"
          @click="beforeClose(() => visible = false)"
        >取消</el-button>
      </div>
    </el-dialog>
  </el-button>
</template>
<script>
import axios from 'bzmj/axios'
export default {
  name: 'BaseFileupload',

  props: {
    type: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String,
      default: '上传文件'
    },
    url: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      default: '.xlsx,.xls,.csv'
    },
    multiple: Boolean,
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    props: Object,
    placeholder: {
      type: String,
      default: '点击“浏览”选择文件'
    },
    center: {
      type: Boolean,
      default: true
    },
    formAttr: Object,
    width: {
      type: [Number, String],
      default: '500px'
    },
    label: String,
    plain: Boolean
  },

  computed: {
    fileProps () {
      return {
        file: 'file',
        ...this.props
      }
    },
    disabled () {
      return this.fileList.length === 0
    },
    inputValue () {
      const { name } = this.fileList[ 0 ] || {}
      return name
    }
  },

  data () {
    return {
      fileList: [],
      visible: false,
      isClear: false,
      source: null
    }
  },

  methods: {
    fileChange (file, fileList) {
      this.fileList = fileList
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = new FormData()
          const fileField = `${this.fileProps.file}${this.multiple ? '[]' : ''}`
          this.fileList.forEach(file => data.append(fileField, file.raw))
          Object.keys(this.data).forEach(key => data.append(key, this.data[ key ]))
          axios.post(this.url, data, {
            headers: {
              'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
            },
            timeout: Infinity,
            loading: 'excel_import',
            cancel: source => (this.source = source)
          }).then(({ data }) => {
            this.$emit('success', data)
            this.visible = false
            this.source = null
            this.beforeClose()
          }).catch(err => {
            this.source = null
            this.$emit('error', err)
          })
        }
      })
    },
    handleClear () {
      this.fileList.shift()
    },
    handleClick (e) {
      if (e.target.className.includes('el-input__clear')) e.stopPropagation()
    },
    handleClose (id) {
      this.fileList = this.fileList.filter(item => item.uid !== id)
    },
    beforeClose (done) {
      if (typeof done === 'function') {
        if (this.source) {
          this.$confirm('确定取消正在上传的文件吗？', {
            type: 'warning'
          }).then(() => {
            this.source && this.source.cancel('用户取消了上传')
            this.source = null
            this.reset(done)
          })
        } else {
          this.reset(done)
        }
      } else {
        this.reset()
      }
    },
    reset (callback) {
      this.$refs.upload.clearFiles()
      this.$refs.form.resetFields()
      this.$nextTick(() => {
        this.fileList = []
        callback && callback()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .excel-import__input {
    float: left;
    margin-right: 10px;
    width: 325px;
  }
  .file-upload__inner {
    margin-bottom: 10px;
    ::v-deep  .el-upload-list {
      float: left;
    }
  }
  .file-upload__filelist {
    padding: 10px 0;
    max-height: 240px;
    overflow: auto;
    ::v-deep  {
      .el-tag {
        position: relative;
        padding-right: 20px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        .el-tag__close {
          position: absolute;
          top: 8px;
          right: 5px;
        }
      }
    }
  }
  .is-center {
    text-align: center;
    .file-upload__wrap {
      display: inline-block;
      text-align: initial;
    }
  }
</style>
